import { useQuery } from '@tanstack/react-query'

import { checkDuplicateEmailAddresses } from '@src/api'
import { DefaultApiCheckDuplicateEmailAddressesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useCheckDuplicateEmailAddresses = (
  params: DefaultApiCheckDuplicateEmailAddressesRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.emailAddresses,
    queryFn: () => checkDuplicateEmailAddresses(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.CHECK_DUPLICATE_EMAIL_ADDRESSES,
      params.emailAddresses,
    ],
  })
}
